import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllLogContratoFinanceiroDetalhadoUseCase } from "../../../presentation/useCases/read/get_all_log_contrato_financeiro_detalhado_use_case";
import { LogContratoFinanceiroDetalhadoModel } from "../../models/log_contrato_financeiro_detalhado";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetAllLogContratoFinanceiroDetalhadoUseCase
 */

export class GetAllLogContratoFinanceiroDetalhadoUseCase extends BasePaginatedUseCase<LogContratoFinanceiroDetalhadoModel> implements IGetAllLogContratoFinanceiroDetalhadoUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { super(); }

  async execute(
    idContratoFinanceiro: number,
    currentPage?: number,
    rowsPerPage?: number
  ): Promise<void> {

    const result = await this.repository.getAllLogContratoFinanceiroDetalhado(
      idContratoFinanceiro,
      currentPage,
      rowsPerPage
    );

    this._items = result.items;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;
  }

}
